module.exports = __webpack_public_path__ + "img/audio-mark2.8bb791a6.png";